import { render, staticRenderFns } from "./dialog_receive_record.vue?vue&type=template&id=1c96903e&scoped=true"
import script from "./dialog_receive_record.vue?vue&type=script&lang=js"
export * from "./dialog_receive_record.vue?vue&type=script&lang=js"
import style0 from "./dialog_receive_record.vue?vue&type=style&index=0&id=1c96903e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96903e",
  null
  
)

export default component.exports